<template>
  <div>
    <v-layout row>
      <v-flex xs12 sm12>
        <v-container
          fluid
          class="subheading font-weight-bold"
          v-if="list && list.length"
        >{{ $t('rms_total_films_label') }}&ensp;{{ list.length }}</v-container>
        <v-divider v-if="list && list.length"></v-divider>
        <!-- Show applied filters (if any) -->
        <AppliedFilters v-if="is_filters_applied" :filters="filters"></AppliedFilters>
        <v-divider v-if="is_filters_applied"></v-divider>
        <v-container fluid grid-list-md v-if="list">
          <v-layout row wrap v-if="list.length">
            <v-flex v-for="(film,index) in list" :key="index" xs6 sm4 md3 lg2 @click="view(film)">
              <v-card height="235px" pa-5 align-center>
                <div v-if="film.thumbs.length" class="media_file_container">
                  <div
                    :style="{
                                  backgroundImage: 'url('+poster(film)+')',
                                  position: 'absolute',
                                  top: '0',
                                  left: '0',
                                  bottom: '0',
                                  right: '0',
                                  backgroundPosition: '50%',
                                  backgroundRepeat: 'no-repeat !important',
                                  backgroundSize: 'contain' }"
                  ></div>
                </div>
                <v-container
                  v-else
                  bg
                  fill-height
                  grid-list-md
                  text-xs-center
                  class="media_file_container"
                >
                  <v-layout row wrap align-center>
                    <v-flex>
                      <v-icon :style="{fontSize:'140px'}">{{ $vuetify.icons.rms_img_not_found}}</v-icon>
                      <div>{{ $t('no_image_available') }}</div>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>

              <v-progress-linear
                class="my-2"
                background-color="red accent-4"
                v-if="is_rights_or_countries_applied && film.hasOwnProperty('available_percentage') "
                :color="film.available_percentage <=   100 ? 'green accent-4': 'red accent-4'"
                :value="available(film.available_percentage)"
              ></v-progress-linear>
            </v-flex>
          </v-layout>

          <v-layout row wrap v-if="(is_filters_applied && !list.length) || !(list.length)">
            <NotFound></NotFound>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>

    <v-layout row class="justify-center">
      <v-btn
        fixed
        bottom
        round
        color="orange accent-4"
        @click="filtersDialog = true"
        class="filter_btn"
      >
        <v-icon left>$vuetify.icons.rms_filter_line</v-icon>Filter movies
      </v-btn>
    </v-layout>

    <FilterMenuDialog :dialog="filtersDialog" v-model="filtersDialog" v-if="filtersDialog" />
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import FilterMenuDialog from "../../components/dialogBox/FilterMenu";
import AppliedFilters from "./AppliedFilters";
import i18n from "@/i18n";

export default {
  name: "Films",
  data() {
    return {
      filtersDialog: false
    };
  },
  mounted() {
    this.setToolbarHeader();
    this.getFilms();
  },
  components: {
    AppliedFilters,
    FilterMenuDialog
  },
  computed: {
    ...mapState({
      selected_company_id: state => state.company.selected_company_id,
      list: state => state.film.list,
      toolbar_drawer: state => state.app.toolbar.drawer
    }),
    ...mapGetters({
      selected_company: "company/getSelectedCompany",
      is_filters_applied: "filter/is_applied",
      filters: "filter/getApplied",
      is_rights_or_countries_applied: "filter/isRightsOrCountriesApplied"
    })
  },
  methods: {
    openFiltersDialog() {},

    available(available_value) {
      return Math.round(available_value);
    },

    poster: function(film) {
      return film.thumburls[film.thumbs[0]];
    },

    openDrawer() {
      this.$store.commit("app/openDrawer");
    },

    async view(film) {
      try {
        await this.$store.dispatch("files/list", {
          model_type: this.DEFINES.MODEL_FILM,
          model_id: film.id
        });
        this.$router.push({
          name: "FilmOverview",
          params: {
            company_id: this.selected_company_id,
            film_id: film.id
          }
        });
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error"
        });
      }
    },

    async setToolbarHeader() {
      await this.$store.dispatch("app/setToolbarHeader", {
        header: i18n.t("rms_films_label")
      });
    },

    async getFilms() {
      if (this.is_filters_applied) {
        var self = this;
        await this.$store.dispatch("filter/listFilms", this.filters);
      } else {
        await this.$store.dispatch("film/list");
      }
    }
  }
};
</script>
<style scoped>
.filter_btn {
  z-index: 1;
}

.media_file_container {
  height: 100%;
  position: relative;
  width: 100%;
  background-color: #333333;
}
</style>

